"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTransformHeightExclude = exports.FieldTransformSelectListReplace = exports.FieldTransformNumberInvert = exports.FieldTransformVectorInvert = exports.FieldTransform = void 0;
const core_api_1 = require("@ikegps/core-api");
class FieldTransform {
    constructor(fieldId, transform) {
        this.fieldId = fieldId;
        this.transform = transform;
    }
    match(from) {
        return true;
    }
    static create(field, transform) {
        if (transform == null) {
            return null;
        }
        const transforms = {
            [core_api_1.IkeFieldType.VECTOR]: {
                invert: FieldTransformVectorInvert
            },
            [core_api_1.IkeFieldType.NUMBER]: {
                invert: FieldTransformNumberInvert
            },
            [core_api_1.IkeFieldType.SELECT_LIST]: {
                replace: FieldTransformSelectListReplace
            },
            [core_api_1.IkeFieldType.HEIGHT]: {
                exclude: FieldTransformHeightExclude
            }
        };
        const fieldTypeTransforms = transforms[field.schema.type];
        if (fieldTypeTransforms == null) {
            return null;
        }
        const transformClass = fieldTypeTransforms[transform.transform];
        if (transformClass == null) {
            return null;
        }
        return new transformClass(field.id, transform);
    }
}
exports.FieldTransform = FieldTransform;
class FieldTransformVectorInvert extends FieldTransform {
    constructor(fieldId, transform) {
        super(fieldId, transform);
    }
    match(from) {
        return from.hasValue();
    }
    apply(to) {
        to.Mutator.reverse();
    }
}
exports.FieldTransformVectorInvert = FieldTransformVectorInvert;
class FieldTransformNumberInvert extends FieldTransform {
    constructor(fieldId, transform) {
        super(fieldId, transform);
    }
    match(from) {
        return from.hasValue();
    }
    apply(to) {
        to.Mutator.reverse();
    }
}
exports.FieldTransformNumberInvert = FieldTransformNumberInvert;
class FieldTransformSelectListReplace extends FieldTransform {
    constructor(fieldId, transform) {
        super(fieldId, transform);
    }
    match(from) {
        const toValue = this.transform.replace[from.value];
        return toValue != null;
    }
    apply(to) {
        const toValue = this.transform.replace[to.value];
        to.Mutator.manual(toValue);
    }
}
exports.FieldTransformSelectListReplace = FieldTransformSelectListReplace;
class FieldTransformHeightExclude extends FieldTransform {
    constructor(fieldId, transform) {
        super(fieldId, transform);
    }
    apply(to) {
        to.Mutator.manual(null);
    }
}
exports.FieldTransformHeightExclude = FieldTransformHeightExclude;
//# sourceMappingURL=field.transform.js.map